/**
 * DDDのservice
 * プレイヤーの停止を制御するクラス
 */
class EndController {
  constructor(player, params) {
    this.player = player;
    this.params = params;
    this.init();
  }

  /**
   * 初期化。
   * 有効・無効を判断。無効なら何もしない
   * 有効の場合はプレイヤーのコールバックを設定
   *
   * @returns bool
   */
  init() {
    // endがfalseなら何もしない
    if (!this.params || !this.params.end) {
      return false;
    }
    // プレイヤーが無効なら何もしない
    if (this.player === false) {
      return false;
    }
    // プレイヤーにコールバックを設定
    this.handleTime();
    return true;
  }

  /**
   * プレイヤーに指定された停止位置で停止するコールバックを設定する
   *
   * @returns void
   */
  handleTime() {
    // 停止フラグ。true:有効、false:無効
    // 停止ゾーン以外で再生されるとリセットされる(trueになる)
    let endFlg = true;

    this.player.on('time', (event) => {
      // 停止ゾーン内ならプレイヤーを停止
      if (endFlg === true && this.isStopZoneAt(event.position)) {
        // this.player.pause(true);
        this.player.stop(true);
        endFlg = false;
      }
      // 停止ゾーン以外ならフラグをリセット
      if (endFlg === false && !this.isStopZoneAt(event.position)) {
        endFlg = true;
      }
    });

  }

  /**
   * 停止ゾーンか判定する
   *    停止ゾーン：停止位置から1秒以内の範囲
   *
   * @param {float} time
   */
  isStopZoneAt(time) {
    // 停止ゾーンの範囲(sec)
    const stopRange = 1;
    return time >= this.params.end && time < this.params.end + stopRange;
  }

  // ***************************
  // getter / setter
  // ***************************
  get player() {
    return this._player;
  }

  /**
   * playerのsetter
   * 無効な場合はfalseを設定する
   *
   * @param {mix} val
   * @returns void
   */
  set player(val) {
    if (!val) {
      val = false;
    } else if (
      typeof(val.on) !== "function"
      // || typeof(val.pause) !== "function"
      || typeof(val.stop) !== "function"
    ) {
      val = false;
    }
    this._player = val;
  }
}

export default EndController;
